import { AUTH_CONSTANTS } from 'constants/auth';

export const handleURL = ({ url, urlParams, userDetails, fieldValue }) => {
  const targetUrl = new URL(window.location.origin + url);
  Object.entries(urlParams).forEach(([key, value]) => {
    if (value) {
      targetUrl.searchParams.set(key, value);
    } else {
      switch (key) {
        case 'userName':
          targetUrl.searchParams.set(key, `@BASE64@${btoa(userDetails.userName)}`);
          break;
        case 'userType':
          targetUrl.searchParams.set(key, userDetails.isAdmin ? AUTH_CONSTANTS.ADMIN : AUTH_CONSTANTS.END_USER);
          break;
        case 'id':
        case 'computerID':
          if (fieldValue !== undefined) {
            targetUrl.searchParams.set(key, fieldValue?.id);
          }
          break;
        default:
      }
    }
  });
  return decodeURIComponent(targetUrl);
}; 